__turbopack_context__.v({
  "caption": "styles-module-scss-module__dd4dca__caption",
  "disabled": "styles-module-scss-module__dd4dca__disabled",
  "dragActive": "styles-module-scss-module__dd4dca__dragActive",
  "dropzone": "styles-module-scss-module__dd4dca__dropzone",
  "enter": "styles-module-scss-module__dd4dca__enter",
  "exit": "styles-module-scss-module__dd4dca__exit",
  "fade-in": "styles-module-scss-module__dd4dca__fade-in",
  "fade-out": "styles-module-scss-module__dd4dca__fade-out",
  "fade-out-80": "styles-module-scss-module__dd4dca__fade-out-80",
  "icon": "styles-module-scss-module__dd4dca__icon",
  "input": "styles-module-scss-module__dd4dca__input",
  "label": "styles-module-scss-module__dd4dca__label",
  "slide-in-from-bottom": "styles-module-scss-module__dd4dca__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__dd4dca__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__dd4dca__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__dd4dca__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__dd4dca__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__dd4dca__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__dd4dca__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__dd4dca__slide-out-to-top",
  "texts": "styles-module-scss-module__dd4dca__texts",
  "zoom-in": "styles-module-scss-module__dd4dca__zoom-in",
  "zoom-out": "styles-module-scss-module__dd4dca__zoom-out",
});
